import { endThisTurn } from './End';
import { getTargetHero, isTargetHeroDead, isSameTeam } from '../index';
import {
  clearActiveHeroTileColor,
  setAvailableAttackTilesColor,
  clearAvailableAttackTilesColor,
  clearAllTilesColor,
} from '../Color';
import AnimationKeys from '../../../constants/AnimationKeys';
import { 
  HERO_INIT_FRAME_LEFT,
  HERO_INIT_FRAME_RIGHT,
} from '../../../configs/Battle';
import AttackKeys from '../../../constants/AttackKeys';

// Initialize available attack tiles of the active hero
export function spawnAvailableAttackTiles() {
  const { posX, posY, attackRange = 1 } = this.activeHero;
  let tile;

  this.availableAttackTiles = [];

  for (let i = 1; i <= attackRange; i++) {
    tile = this.tiles?.[posX - i]?.[posY];
    if (tile) {
      this.availableAttackTiles.push({ posX: posX - i, posY });
    }
    tile = this.tiles?.[posX + i]?.[posY];
    if (tile) {
      this.availableAttackTiles.push({ posX: posX + i, posY });
    }

    for (let j = 1; j <= attackRange - i; j++) {
      tile = this.tiles?.[posX - i]?.[posY - j];
      if (tile) {
        this.availableAttackTiles.push({ posX: posX - i, posY: posY - j });
      }
      tile = this.tiles?.[posX - i]?.[posY + j];
      if (tile) {
        this.availableAttackTiles.push({ posX: posX - i, posY: posY + j });
      }
      tile = this.tiles?.[posX]?.[posY - j];
      if (tile) {
        this.availableAttackTiles.push({ posX, posY: posY - j });
      }
      tile = this.tiles?.[posX]?.[posY + j];
      if (tile) {
        this.availableAttackTiles.push({ posX, posY: posY + j });
      }
      tile = this.tiles?.[posX + i]?.[posY - j];
      if (tile) {
        this.availableAttackTiles.push({ posX: posX + i, posY: posY - j });
      }
      tile = this.tiles?.[posX + i]?.[posY + j];
      if (tile) {
        this.availableAttackTiles.push({ posX: posX + i, posY: posY + j });
      }
    }
  }

  tile = this.tiles?.[posX]?.[posY - attackRange];
  if (tile) {
    this.availableAttackTiles.push({ posX, posY: posY - attackRange });
  }
  tile = this.tiles?.[posX]?.[posY + attackRange];
  if (tile) {
    this.availableAttackTiles.push({ posX, posY: posY + attackRange });
  }

  clearAllTilesColor.call(this, false);
  setAvailableAttackTilesColor.call(this);
  this.availableMoveTiles = [];
}

// Clear available attack tiles of the active hero
export function clearAvailableAttackTiles() {
  clearAllTilesColor.call(this, false);
  this.availableAttackTiles = [];
}

// Attack an opponent hero at target position
export function attackHero(hero, opponentHero, posX, posY) {
  const { id, isoSprite: heroSprite, posX: heroPosX, posY: heroPosY, attackType } = hero;
  const { id: opponentHeroId, isoSprite: opponentHeroSprite } = opponentHero
  const attackLeft = (heroPosX > posX && heroPosY <= posY) ||
    (heroPosX === posX && heroPosY < posY);

  let heroAttackAnimationKey;
  switch (attackType) {
    case AttackKeys.Thrust: {
      if (attackLeft) {
        heroAttackAnimationKey = `${AnimationKeys.HeroThrustLeft}-${id}`;
      } else {
        heroAttackAnimationKey = `${AnimationKeys.HeroThrustRight}-${id}`;
      }
      break;
    }
    case AttackKeys.Shoot: {
      if (attackLeft) {
        heroAttackAnimationKey = `${AnimationKeys.HeroThrustLeft}-${id}`;
      } else {
        heroAttackAnimationKey = `${AnimationKeys.HeroThrustRight}-${id}`;
      }
      break;
    }
    default: {
      if (attackLeft) {
        heroAttackAnimationKey = `${AnimationKeys.HeroSlashLeft}-${id}`;
      } else {
        heroAttackAnimationKey = `${AnimationKeys.HeroSlashRight}-${id}`;
      }
      break;
    }
  }

  heroSprite.anims.play(heroAttackAnimationKey, true);
  heroSprite.once('animationcomplete', function ({ key: heroAnimationKey }) {
    if (heroAnimationKey === heroAttackAnimationKey) {
      this.cameras.main.shake(100, 0.01);
      heroSprite.anims
        .stop()
        .setFrame(attackLeft ? HERO_INIT_FRAME_LEFT : HERO_INIT_FRAME_RIGHT);
  
      const opponentWillDie = true; // TODO: Check if opponent will die by HP
      if (!opponentWillDie) {
        endThisTurn.call(this);
        return;
      }

      const heroDieAnimationKey = `${AnimationKeys.HeroHurt}-${opponentHeroId}`;
      opponentHeroSprite.play(heroDieAnimationKey, true);
      opponentHeroSprite.once('animationcomplete', function ({ key: opponentHeroAnimationKey }) {
        if (opponentHeroAnimationKey === heroDieAnimationKey) {
          opponentHeroSprite.anims.stop();
          this.deadHeros.push(opponentHero);
          endThisTurn.call(this);
        }
      }, this);
    }
  }, this);
}

// Get ready to attack an opponent hero
export function preAttackHero(isoX, isoY) {
  for (let i = 0; i < this.availableAttackTiles.length; i++) {
    const { posX, posY } = this.availableAttackTiles[i];
    const tile = this.tiles[posX][posY];

    if (isoX === tile.isoX && isoY === tile.isoY) {
      const opponentHero = getTargetHero.call(this, tile);
      if (
        !opponentHero
          || isTargetHeroDead.call(this, opponentHero)
          || isSameTeam.call(this, this.activeHero, opponentHero)
      ) {
        return;
      }
      clearActiveHeroTileColor.call(this);
      clearAvailableAttackTilesColor.call(this);
      this.availableAttackTiles = [];
      attackHero.call(this, this.activeHero, opponentHero, posX, posY);
      break;
    }
  }
}
